module.exports = __webpack_public_path__ + "img/home-banner-2-mobile.93565b43.png";